import User from './user';
import Job from './job';
import Common from './common';
import Delivery from './delivery'
import JobFilterReducer from './jobFilter';
import JobRequestFilterReducer from './jobRequestFilter';
import RefundFilterReducer from './refundFilter';
import CustomerJobReportsFilterReducer from './customerJobReportsFilter';
import AdditionalPaymentFilterReducer from './additionalPaymentFilter';
import CspInfoFilterReducer from './cspInfoFilter';
import commonFiltersReducer from './commonFilters';
import PaymentLinkReducer from './paymentLinkFilter';
import {combineReducers} from 'redux';
import EidAppointmentFilter from  './eidAppointmentFilter';

export default combineReducers({
    User,
    Common,
    Job,
    Delivery,
    jobFilter: JobFilterReducer,
    jobRequestFilter: JobRequestFilterReducer,
    customerJobReportsFilter: CustomerJobReportsFilterReducer,
    refundFilter: RefundFilterReducer,
    additionalPaymentFilter: AdditionalPaymentFilterReducer,
    cspInfoFilter: CspInfoFilterReducer,
    commonFilters: commonFiltersReducer,
    paymentLinkFilter: PaymentLinkReducer,
    eidAppointmentFilter: EidAppointmentFilter
});